<template>
    <li class="c-header-nav-more-social">
        <a class="c-header-nav-more-social__link" :href="social.url" target="_blank" rel="noopener">
            <icon class="c-header-nav-more-social__link__icon" :icon="social.name" />{{ social.name }}
        </a>
    </li>
</template>

<script>
import Icon from "objects/Icon";
export default {
    components: {
        Icon
    },
    props: {
        social: {
            type: Object,
            required: true
        }
    }
};
</script>

<style lang="scss">
.c-header-nav-more-social {
    display: flex;
    align-items: center;
    &__link {
        display: flex;
        text-transform: capitalize;
        margin-right: var(--grid-gutter-double);
        &__icon {
            padding-right: var(--grid-gutter-half);
        }
        &:hover {
            @include transition(0.3s ease all);
            opacity: 0.5;
        }
    }
}
</style>
